<div class="fiscal-panel-container">
  <pds-module-header title="Painel Fiscal" ctaLabel="Voltar" ctabuttonType="primary" ctaPath=".." height="100%" style="overflow: hidden">
    <pds-new-breadcrumb [items]="breadcrumb" />
    <section class="fiscal-panel-container__panel" height="100%" style="overflow: hidden">
      <peca-fiscal-panel-search (search)="onSearch($event)" />
      <hr />
      <peca-kanban cdkDropListGroup>
        <peca-kanban-column
          [indicator]="pendingOrdersPagination().items || 0"
          title="PEDIDO DE COMPRA PENDENTE"
          [cardsLoading]="pendingOrders().loading || false"
          [cardsFailed]="pendingOrders().failure || false"
          [isEmpty]="!pendingOrders().data?.length"
          (retry)="fetchPendingOrders(pendingOrdersQuery)"
          [emptyMessage]="'Nenhum pedido de compra pendente encontrado'"
          class="column-pending-order"
        >
          @for (pendingOrder of pendingOrders().data; track $index) {
          <peca-kanban-card-purchase
            [tittle]="pendingOrder.order?.commerceReference || ''"
            [amount]="pendingOrder.amount"
            [date]="pendingOrder.audit?.createdAt || 'dd/MM/yyyy'"
            [branchName]="pendingOrder.branch.companyName"
            (clickCard)="openPictureInPicture(pendingOrder.id)"
            (clickRemove)="onClickRemovePendingOrders(pendingOrder.id, pendingOrder.order?.commerceReference || '')"
            [showRemove]="true"
            (clickSendOmie)="onClickSendOmie(pendingOrder.id)"
            [showSendToOmie]="true"
            cdkDropList
            [cdkDropListData]="[pendingOrder]"
            [cdkDropListConnectedTo]="['invoice-seller']"
            (cdkDropListDropped)="onDropNfOnOrder($event, pendingOrder)"
            id="pending-order"
          />
          }
          <peca-load-more [pagination]="pendingOrdersPagination()" (loadMore)="onLoadMorePendingOrders($event)" />
        </peca-kanban-column>
        <peca-kanban-column
          [indicator]="invoiceSellerPagination().items || 0"
          title="NOTA FISCAL DO SELLER"
          [cardsLoading]="invoiceSeller().loading || false"
          [cardsFailed]="invoiceSeller().failure || false"
          [isEmpty]="!invoiceSeller().data?.length"
          id="invoice-seller"
          cdkDropList
          [cdkDropListData]="invoiceSeller().data"
          [cdkDropListConnectedTo]="['pending-order']"
          [cdkDropListSortingDisabled]="true"
          (retry)="fetchInvoiceSeller(invoiceSellerQuery)"
          [emptyMessage]="'Nenhuma NF-e encontrada'"
        >
          @for (invoiceSeller of invoiceSeller().data; track $index) {
          <peca-kanban-card-purchase
            class="card-invoice-seller"
            [class.--dragable]="!disableDragAndDrop()"
            [cdkDragDisabled]="disableDragAndDrop()"
            cdkDrag
            [tittle]="'NF-e ' + invoiceSeller.code"
            [amount]="invoiceSeller.amount"
            [date]="invoiceSeller.audit?.createdAt || 'dd/MM/yyyy'"
            [branchName]="invoiceSeller.branch.companyName || invoiceSeller.branch.cnpj"
            [commerceReference]="invoiceSeller.commerceReference"
            [withoutRegister]="!invoiceSeller?.branch?.companyName"
            (clickRemove)="onClickRemoveNf(invoiceSeller.id, invoiceSeller.code)"
            [showRemove]="true"
            [cdkDragData]="invoiceSeller"
            (click)="onClickNfe(invoiceSeller.key)"
            [conciliationFailure]="invoiceSeller.conciliationFailure"
            (clickConciliationFailure)="modalConciliationFailure.open(invoiceSeller.conciliationFailure!, invoiceSeller.code, invoiceSeller.commerceReference)"
          />
          }
          <peca-load-more [pagination]="invoiceSellerPagination()" (loadMore)="onLoadMoreInvoiceSeller($event)" />
        </peca-kanban-column>
        <peca-kanban-column
          [indicator]="invoiceReconciledPagination().items || 0"
          [cardsLoading]="invoiceReconciled().loading || false"
          [cardsFailed]="invoiceReconciled().failure || false"
          [isEmpty]="!invoiceReconciled().data?.length"
          (retry)="fetchInvoiceReconciledOrders(invoiceReconciledQuery)"
          [emptyMessage]="'Nenhuma NF-e reconciliada encontrada'"
          title="RECEBIDO"
        >
          @for (invoiceReconciled of invoiceReconciled().data; track $index) {
          <peca-kanban-card-reconciled
            class="card-invoice-reconciled"
            [tittle]="invoiceReconciled.order?.commerceReference || ''"
            [order]="{
        date: invoiceReconciled.audit?.createdAt || 'dd/MM/yyyy',
        amount: invoiceReconciled.amount,
        commerceReference: invoiceReconciled.order?.commerceReference || '',
      }"
            [sendWithoutNf]="invoiceReconciled.invoice?.id ? false : true"
            [nf]="{
              date: invoiceReconciled?.invoice?.emittedAt || '',
              amount: invoiceReconciled?.invoice?.amount || 0,
              code: invoiceReconciled?.invoice?.code || ''
            }"
            [branchName]="invoiceReconciled.branch.companyName"
            (clickCard)="openPictureInPicture(invoiceReconciled.id)"
          />}
          <peca-load-more [pagination]="invoiceReconciledPagination()" (loadMore)="onLoadMoreInvoiceReconciled($event)" />
        </peca-kanban-column>
      </peca-kanban>
    </section>
  </pds-module-header>
</div>
<peca-fiscal-panel-modal-remove-order #modalRemoveOrder (confirm)="removePendingOrder($event)" />
<peca-fiscal-panel-modal-send-omie #modalSendOmie (confirm)="sendToOmie($event.orderId, $event.nfCode)" />
<peca-fiscal-panel-modal-conciliation-failure #modalConciliationFailure />
<pds-picture-in-picture [routerOpenInNew]="['..', 'pedidos-de-compra', selectedOrderId()]" [title]="'Detalhes do Pedido de Compra'" [height]="'80%'" [width]="'70%'" #pip>
  @if (pip.active()) {
  <peca-purchase-order-details [orderId]="selectedOrderId()" [useRouting]="false" #pipPurchaseOrder />
  }
</pds-picture-in-picture>
<peca-document-preview #documentPreview [disableDeleteAction]="true" />
